import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
import { UiProvider } from '../ui/ui';
import { App } from 'ionic-angular';
import { ConfigDataProvider } from '../config-data/config-data';
import { TranslateProvider } from '../translate/translate';


@Injectable()
export class ApiProvider {

	public baseUrl = 'https://login.opyx.net';
	public apiUrl = this.baseUrl + '/';
	// public getUrl = 'https://login.opyx.net/mobile/'
	private getUrl = this.baseUrl + '/mobile/'

	constructor(
		private http: HttpClient,
		private uiProvider: UiProvider,
		private app: App,
		private configDataPrvdr: ConfigDataProvider,
		private translateProvider: TranslateProvider
	) {

	}

	public post(url, data): Observable<any> {

		let header = new HttpHeaders();

		if (url == "saveMessagesBeta" || url == "saveEvents") {

			url = "mobile/" + url
			header = new HttpHeaders();
			header = header.set("Content-Type", "application/json");
		}

		if (url == "saveAttachments2") {
			url = "mobile/" + url;
		}

		let endPoint = this.apiUrl + url;
		return this.http.post(endPoint, data, {
			headers: header
		}).pipe(mergeMap(this.responseParser));

	}

	public get(url): Observable<any> {

		let endPoint = this.getUrl + url;
		return this.http.get(endPoint).pipe(mergeMap(this.responseParser));

	}

	public pipeLoader(observable: Observable<any>) {

		let loader = this.uiProvider.getLoader();
		loader.present();

		return observable.pipe(mergeMap((data) => {
			return new Promise((resolve, reject) => {
				loader.dismiss().then(() => {
					resolve(data);
				});
			});
		}), catchError((err) => {
			return new Promise((resolve, reject) => {
				loader.dismiss().then(() => {
					reject(err);
				});
			});
		}));
	}

	public pipeErrorToaster(observable: Observable<any>) {

		return observable.pipe(catchError((err: Error) => {

			return new Observable((observer: Observer<any>) => {

				if (err.name == 'HttpErrorResponse')
					err.message = this.translateProvider.getTranslateKey('SOMETHING_WENT_WRONG_ERROR');

				let error: any = err;
				if (error.error && error.error.error == 'session_expired') {
					this.configDataPrvdr.clearLocalStorage();
					this.app.getRootNav().setRoot("LoginPage", {}, {
						animate: true
					});
				}

				this.uiProvider.showError(err.message);
				observer.error(err)
				observer.complete()
			});

		}));

	}

	public responseParser(response) {

		if (!response) {
			throw new Error(this.translateProvider.getTranslateKey('SOMETHING_WENT_WRONG_ERROR'));
		}
		if (!response.status) {
			let msg = response.msg || response.message || "Unknown error occurred";
			throw new Error(msg);
		}
		return of(response);

	}


}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts